import { ApplicantState, Applicant } from "../types";

export const BaseApplicant: Applicant = {
  adminApproval: "",
  adminApprovalDate: "",
  approvalScore: 0,
  completed: false,
  completedAt: "",
  createdAt: "",
  faceMatchScore: 0,
  idDocumentData: {
    address1: "",
    address2: "",
    authenticationScore: 0,
    backImageUrl: "",
    frontImageUrl: "",
    dateOfBirth: "",
    documentNumber: "",
    documentType: "",
    expirationDate: "",
    firstName: "",
    lastName: "",
    fullName: "",
    id: "",
    issueDate: "",
    issuingCountry: "",
    nationality: "",
    sex: "",
    rawData: "",
  },
  selfieCode: 0,
  selfieTurnDirection: "",
  selfieData: {
    id: "",
    nearImageUrl: "",
    farImageUrl: "",
    thumbnailUrl: "",
    videoUrl: "",
  },
  email: "",
  firstName: "",
  middleName: "",
  lastName: "",
  thumbnailUrl: "",
  status: "",
  vendorApproval: "",
  vendorApprovalDate: "",
  approvedByUser: {
    id: "",
    firstName: "",
    lastName: "",
    middlename: "",
    email: "",
  },
  verificationProcessStep: "",
};

const state: ApplicantState = {
  currentApplicant: {
    ...BaseApplicant,
  },
  isViewing: "all",
  applicants: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  allApprovedApplicants: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  allRejectedApplicants: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  allPendingApplicants: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  sortOrder: "desc",
  sortBy: "creationDate",
  isLoadingCurrentApplicant: false,
  isFetchingApplicants: false,
  query: "",
  audits: {
    pageIndex: 1,
    totalPages: 0,
    totalItems: 0,
    items: [],
    hasPreviousPage: false,
    hasNextPage: false,
  },
  entityId: "",
  isFetchingApplicantAudits: false
};

export default state;
